package com.patronat.top.features.dashboard.data.repository

import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.dto.DashboardStatsResponse
import com.patronat.top.features.dashboard.data.network.DashboardRemoteDataStore
import com.patronat.top.features.dashboard.domain.repository.DashboardRepository

class DashboardRepositoryImpl(
    private val remoteDataStore: DashboardRemoteDataStore
) : DashboardRepository {

    override suspend fun getDashboardStats(): DomainResult<DashboardStatsResponse> {
        return remoteDataStore.getDashboardStats().asDomainResult { it }
    }
}
